module.exports = __webpack_public_path__ + "img/NChow.3fb9bec7.jpg";